import { React } from 'react'
import { CImage, CButton, CModal, CModalBody } from '@coreui/react'
import DummyImg from '../../../assets/livestream-OBS-dummy.png'

const LiveStreamOBSInfoModal = ({ onNext }) => {
  return (
    <CModal size="lg" visible={true} alignment="center" className="obs-modal border-0">
      <CModalBody
        className="m-auto p-0 rounded-sm overflow-hidden"
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end',
          borderRadius: '10px',
        }}
      >
        <div
          className=" d-flex flex-column justify-content-between align-items-start bg-white"
          style={{
            padding: '2rem 2rem 2rem 2rem',
          }}
        >
          <div style={{ paddingRight: '2rem' }}>
            <h4 className="font-bold text-black">{`Let's create your Live Stream!`}</h4>
            <p className="">
              <small style={{ fontSize: '.75rem' }}>
                {` To create your first live stream, you'll need a camera that sends RTMP-encoded video (Real-Time Messaging Protocol).`}
              </small>
            </p>
            <p className="">
              <small style={{ fontSize: '.75rem' }}>
                {`If you don't have an RTMP camera, we recommend that you download and use OBS Studio. OBS (Open Broadcaster Software) is free and open source software for video recording and live streaming.`}
              </small>
            </p>
            <p className="">
              <small style={{ fontSize: '.75rem' }}>
                {`Know how to connect  OBS with OTTDock Live Studeo:`}{' '}
                <a
                  href="https://www.youtube.com/watch?v=DTk99mHDX_I"
                  target="_blank"
                  rel="noreferrer"
                >{`https://www.youtube.com/watch?v=DTk99mHDX_I`}</a>
              </small>
            </p>
          </div>
          <div className="d-flex justify-content-end w-100">
            <CButton
              style={{ border: '1px solid black', fontSize: '.75rem' }}
              className="ml-2 bg-black rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={onNext}
            >
              Next
            </CButton>
          </div>
        </div>
        <CImage src={DummyImg} width="42%" height="100%" fluid align="end" />
      </CModalBody>
    </CModal>
  )
}

export default LiveStreamOBSInfoModal
